export function parseMultiBoxName(name) {
    if (!name) return null;
    const match = name.match(/\s-\sBox\s(\d+)$/i);
    if (!match) return null;
    return {
        baseName: name.slice(0, match.index),
        boxNumber: parseInt(match[1], 10),
    };
}

export function getBoxNumberFromName(name, fallback = 1) {
    const parsed = parseMultiBoxName(name);
    return parsed ? parsed.boxNumber : fallback;
}

export function getPackingSlipItemCount(packingSlip) {
    return packingSlip?.items?.length || 0;
}

export function isPackingSlipFullyReceived(packingSlip) {
    if (!packingSlip) return false;
    if (getPackingSlipItemCount(packingSlip) === 0) return true;
    if (typeof packingSlip.isFullyReceived === 'boolean') return packingSlip.isFullyReceived;

    const totalExpected = packingSlip.items.reduce((sum, item) => sum + (item.quantityExpected || 0), 0);
    const totalReceived = packingSlip.items.reduce((sum, item) => sum + (item.quantityReceived || 0), 0);
    return totalReceived >= totalExpected;
}

export function getShipmentBoxesForPackingSlip(packingSlips, packingSlip) {
    if (!packingSlip) {
        return { baseName: null, boxes: [], boxNumber: 1, isMultiBox: false };
    }

    const parsed = parseMultiBoxName(packingSlip.name);
    if (!parsed) {
        return {
            baseName: null,
            boxes: [packingSlip],
            boxNumber: 1,
            isMultiBox: false,
        };
    }

    const boxes = (packingSlips || [])
        .filter((ps) => {
            const boxParsed = parseMultiBoxName(ps.name);
            return boxParsed && boxParsed.baseName.toLowerCase() === parsed.baseName.toLowerCase();
        })
        .sort((a, b) => getBoxNumberFromName(a.name) - getBoxNumberFromName(b.name));

    return {
        baseName: parsed.baseName,
        boxes: boxes.length > 0 ? boxes : [packingSlip],
        boxNumber: parsed.boxNumber,
        isMultiBox: boxes.length > 1,
    };
}

export function getPackingSlipAttachedFile(packingSlip, packingSlips = []) {
    const directUrl = packingSlip?.fileUrl || packingSlip?.FileUrl;
    const directName = packingSlip?.fileName || packingSlip?.FileName;
    if (directUrl) {
        return {
            url: directUrl,
            name: directName || packingSlip?.name || 'packing-slip-file',
        };
    }

    const { boxes } = getShipmentBoxesForPackingSlip(packingSlips, packingSlip);
    const boxWithFile = (boxes || []).find((box) => box?.fileUrl || box?.FileUrl);
    if (!boxWithFile) {
        return { url: '', name: '' };
    }

    return {
        url: boxWithFile.fileUrl || boxWithFile.FileUrl,
        name: boxWithFile.fileName || boxWithFile.FileName || packingSlip?.name || 'packing-slip-file',
    };
}

export function withShipmentFile(packingSlip, packingSlips = []) {
    if (!packingSlip) return packingSlip;
    const file = getPackingSlipAttachedFile(packingSlip, packingSlips);
    if (!file.url) return packingSlip;
    return {
        ...packingSlip,
        fileUrl: packingSlip.fileUrl || packingSlip.FileUrl || file.url,
        fileName: packingSlip.fileName || packingSlip.FileName || file.name,
    };
}

export function getPackingSlipBoxEditorUrl(packingSlipId) {
    return `/admin/packing-slips/box/${packingSlipId}`;
}

export function navigateToPackingSlipBoxEditor(history, packingSlipId, event) {
    const url = getPackingSlipBoxEditorUrl(packingSlipId);
    if (event && (event.ctrlKey || event.metaKey)) {
        window.open(url, '_blank');
        return;
    }
    if (history) {
        history.push(url);
    } else {
        window.location.href = url;
    }
}
